/* ============================================
   CART DRAWER — Shopify AJAX Cart
   ============================================ */

class CartDrawer {
  constructor() {
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.itemsContainer = document.querySelector('.cart-drawer__items');
    this.subtotalEl = document.querySelector('.cart-drawer__subtotal-amount');
    this.countEls = document.querySelectorAll('[data-cart-count]');
    this.titleCountEl = document.querySelector('.cart-drawer__count');

    this.bindEvents();
  }

  bindEvents() {
    // Open cart
    document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    // Close cart
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    document.querySelector('.cart-drawer__close')?.addEventListener('click', () => this.close());
    document.querySelector('.cart-drawer__continue')?.addEventListener('click', () => this.close());

    // Add to cart forms
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart(form);
      });
    });

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    });
  }

  isOpen() {
    return this.drawer?.classList.contains('is-open');
  }

  open() {
    this.drawer?.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.refreshCart();
  }

  close() {
    this.drawer?.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async addToCart(form) {
    const formData = new FormData(form);
    const data = {
      items: [{
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity') || 1)
      }]
    };

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (response.ok) {
        this.open();
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
    }
  }

  async refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.renderCart(cart);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  renderCart(cart) {
    // Update count
    this.countEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (this.titleCountEl) {
      this.titleCountEl.textContent = `(${cart.item_count})`;
    }

    // Update subtotal
    if (this.subtotalEl) {
      this.subtotalEl.textContent = this.formatMoney(cart.total_price);
    }

    // Render items
    if (!this.itemsContainer) return;

    if (cart.item_count === 0) {
      this.itemsContainer.innerHTML = `
        <div class="cart-drawer__empty">
          <p>Your bag is empty</p>
        </div>
      `;
      return;
    }

    this.itemsContainer.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}">
        <img class="cart-item__image" src="${item.image}" alt="${item.title}" width="80" height="80" loading="lazy">
        <div class="cart-item__details">
          <span class="cart-item__title">${item.product_title}</span>
          <span class="cart-item__variant">${item.variant_title || ''}</span>
          <div class="cart-item__bottom">
            <div class="quantity-selector">
              <button type="button" onclick="cartDrawer.updateQuantity('${item.key}', ${item.quantity - 1})">−</button>
              <input type="number" value="${item.quantity}" min="0" readonly>
              <button type="button" onclick="cartDrawer.updateQuantity('${item.key}', ${item.quantity + 1})">+</button>
            </div>
            <span class="cart-item__price">${this.formatMoney(item.final_line_price)}</span>
          </div>
          <button class="cart-item__remove" onclick="cartDrawer.removeItem('${item.key}')">Remove</button>
        </div>
      </div>
    `).join('');
  }

  async updateQuantity(key, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });

      if (response.ok) {
        const cart = await response.json();
        this.renderCart(cart);
      }
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  async removeItem(key) {
    return this.updateQuantity(key, 0);
  }

  formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }
}

// Initialize
let cartDrawer;
document.addEventListener('DOMContentLoaded', function() {
  cartDrawer = new CartDrawer();
});
